'use strict';

var styled = require('styled-components');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const getBackgroundColor = ({ activeStep, completed, theme }) => {
    if (completed)
        return theme.designTokens.stepperBackgroundColorCompleted;
    if (activeStep)
        return theme.designTokens.stepperBackgroundColorCurrent;
    else
        return theme.designTokens.stepperBackgroundColorNotCompleted;
};
const getBorder = ({ completed, theme }) => completed ? `solid 1px ${theme.designTokens.stepperBackgroundColorCurrent}` : '';
const getWidth = ({ completed, theme }) => completed ? `calc(${theme.designTokens.stepperBadgeWidth} - 2px)` : theme.designTokens.stepperBadgeWidth;
const getHeight = ({ completed, theme }) => completed ? `calc(${theme.designTokens.stepperBadgeWidth} - 2px)` : theme.designTokens.stepperBadgeHeight;
const getColor = ({ completed, theme }) => completed ? theme.designTokens.stepperBackgroundColorCurrent : theme.designTokens.stepperFontColor;
const getColorStepLink = ({ activeStep, theme }) => activeStep ? theme.designTokens.stepperLinkColorCurrent : theme.designTokens.stepperLinkColorNotCurrent;
const StepBadge = styled__default.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${getHeight};
  width: ${getWidth};
  border-radius: ${({ theme }) => theme.designTokens.stepperBadgeRadius};
  border: ${getBorder};
  background-color: ${getBackgroundColor};
  color: ${getColor};
  font-family: ${({ theme }) => theme.designTokens.stepperFontFamily};
  font-size: ${({ theme }) => theme.designTokens.stepperFontSize};
  font-weight: ${({ theme }) => theme.designTokens.stepperFontWeight};
`;
const StepLink = styled__default.default.div `
  font-size: ${({ theme }) => theme.designTokens.stepperFontSize};
  color: ${getColorStepLink};
  letter-spacing: ${({ theme }) => theme.designTokens.stepperLinkLetterSpacing};
  line-height: ${({ theme }) => theme.designTokens.stepperLinkLetterSpacing};
  font-family: ${({ theme }) => theme.designTokens.stepperFontFamily};
  font-weight: ${({ theme }) => theme.designTokens.stepperFontWeight};
  ${({ isClickable, theme }) => isClickable
    ? `&:hover { color: ${theme.designTokens.stepperLinkColorCurrent};
    text-decoration: ${theme.designTokens.stepperLinkColorTextDecoration};
    cursor: pointer;
}`
    : ''}
`;
const Styled = {
    StepLink,
    StepBadge,
};

exports.Styled = Styled;
exports.getBackgroundColor = getBackgroundColor;
exports.getBorder = getBorder;
exports.getColor = getColor;
exports.getColorStepLink = getColorStepLink;
exports.getHeight = getHeight;
exports.getWidth = getWidth;
//# sourceMappingURL=styles.js.map
